var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 12.95C10.2809 12.95 12.95 10.2809 12.95 7C12.95 3.7191 10.2809 1.05 7 1.05C3.7191 1.05 1.05 3.7191 1.05 7C1.05 10.2809 3.7191 12.95 7 12.95ZM7 -1.56563e-06C10.8598 -1.2282e-06 14 3.1402 14 7C14 10.8598 10.8598 14 7 14C3.1402 14 -6.79149e-07 10.8598 -3.41715e-07 7C-4.28042e-09 3.1402 3.1402 -1.90307e-06 7 -1.56563e-06Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.0043 6.03932C7.2941 6.03932 7.5293 6.27452 7.5293 6.56432L7.5293 9.65762C7.5293 9.94742 7.2941 10.1826 7.0043 10.1826C6.7145 10.1826 6.4793 9.94742 6.4793 9.65762L6.4793 6.56432C6.4793 6.27452 6.7145 6.03932 7.0043 6.03932Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99718 3.64199C7.38428 3.64199 7.70068 3.95489 7.70068 4.34199C7.70068 4.72909 7.39058 5.04199 7.00418 5.04199L6.99718 5.04199C6.61008 5.04199 6.29718 4.72909 6.29718 4.34199C6.29718 3.95489 6.61008 3.64199 6.99718 3.64199Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.08a4a9a33bb44f95b4a6fdac1ef3dce3.svg";
export { ForwardRef as ReactComponent };